<template>
  <div :class="{ container: !isMobile, 'pb-70': isMobile }">
    <div style="padding-bottom: 20px">
      <el-button style="width: 100% !important" @click="goToList">
        Вернуться к списку
      </el-button>
    </div>
    <el-row :gutter="24">
      <el-col :span="24">
        <el-form ref="formAddAuto" :model="dataForSave" @submit.native.prevent>
          <div class="my_container-card">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>
                  <b>Добавление автомобиля</b>
                </span>
              </div>
              <section class="my_container">
                <add-new-auto-in-progress
                  :carrier-inn="carrierInn"
                  :carrier-name="carrierName"
                  @clear="clearForm"
                  @saved="setAutoId"
                  @editAuto="editAuto"
                />
              </section>
            </el-card>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <auto-edit :edit-auto="idEditAuto" @updated="updateAuto" />
  </div>
</template>

<script>
import { CREATE_AUTO_ON_REQUEST } from '@/store/actions/responseRequest'
import { mapActions, mapGetters } from 'vuex'
import { mapMutations } from 'vuex/dist/vuex.esm.browser'
import AddNewAutoInProgress from '@/views/LoadDay/Modals/components/AddNewAutoInProgress'
import AutoEdit from '@/views/Autopark/Auto-edit'

export default {
  name: 'AddForm',
  components: {
    AddNewAutoInProgress,
    AutoEdit,
  },
  props: {
    carrierInn: {
      type: String,
      default: '',
    },
    carrierName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      car: { id: 0, isOwner: 1 },
      reason: 1,
      dataForSave: {
        user_org_inn: '',
        sts: '',
        sts_date: '',
        mark: '',
        plateTrailer: '',
        stsTrailer: '',
        vehicle_type_id: 1,
      },
      idEditAuto: {},
      autoSaved: false,
      helper: this.defaultHelper,
      defaultHelper:
        'Данный раздел предназначен для добавления автомобилей в аккредитацию',
    }
  },
  computed: {
    ...mapGetters({ autoTypes: 'autos/getAutoTypes' }),
  },
  mounted() {
    this.setOwnerParams()
    this.fetchAutoTypes()
  },
  methods: {
    ...mapActions({ fetchAutoTypes: 'autos/fetchAutoTypes' }),
    ...mapMutations({
      updateAutoList: `responseRequest/${CREATE_AUTO_ON_REQUEST}`,
    }),
    setOwnerParams() {
      const { inn, short_name } = this.userInfo.current.organization

      this.dataForSave.innCarrier = inn
      this.dataForSave.user_org_inn = inn
      this.dataForSave.innOwner = inn
      this.dataForSave.nameCarrier = short_name
      this.dataForSave.nameOwner = short_name
    },
    goToList() {
      this.$emit('close')
    },
    editAuto(idAuto) {
      this.idEditAuto = idAuto
    },
    clearForm() {
      this.car = { id: 0 }
    },
    updateAuto(data) {
      for (let key in data) {
        this.dataForSave[key] = data[key]
      }
    },
    setAutoId(plate) {
      this.updateAutoList(plate)
    },
  },
}
</script>

<style lang="sass">
.my_container-card .el-card__body
  padding: 10px
.classAlertError
  width: 100% !important
.add-new_car
  .results
    span
      font-size: 13px
      line-height: 19px
      color: #B5B5B5
    p
      margin: 0
      font-size: 14px
      line-height: 17px
  .search-button
    font-weight: bold
    font-size: 14px
    line-height: 17px
    text-align: center
    text-transform: uppercase
    color: #778CA2
    background: #F2F4F6
    border-radius: 4px
    border: none
    height: 46px
    width: 150px
    &:hover
      cursor: pointer
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
      transition: all 0.2s
</style>
